import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const SurfaceAreaPlot = forwardRef(({ metrics }, ref) => {
  const [positions, setPositions] = useState([]);
  const [surfaceAreaValues, setSurfaceAreaValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let surfaceArea = [];

    metrics.forEach((metric, i) => {
      positions.push(i + 1);

      surfaceArea.push(metric.hasOwnProperty("surfaceArea") ? metric.surfaceArea : NaN);
    });

    setPositions(positions);
    setSurfaceAreaValues(surfaceArea);

    return () => {
      setPositions([]);
      setSurfaceAreaValues([]);
    };
  }, [metrics]);

  const surfaceAreaData = {
    labels: positions,
    datasets: [
      {
        label: t("reports_surfaceArea"),
        data: surfaceAreaValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("reports_surfaceArea")}
        Type={Line}
        data={surfaceAreaData}
        axisY={t("reports_surfaceArea")}
        axisX={t("sessions")}
        graphicDescription={t("graphics_surfaceAreaDescription_App")}
        isBeta
      />
    </GraphicContainer>
  );
});

export default SurfaceAreaPlot;
